import Button from "@mui/material/Button";
import { PublicAuthShell } from "./PublicAuthShell";

// Tela mostrada após o envio do cadastro público de sócio: confirma o
// recebimento e leva de volta ao login. A aprovação é manual (administração
// do Clube), por isso o texto pede para aguardar a confirmação.
export const RegisterPageSuccess = () => {
  return (
    <PublicAuthShell
      title="Cadastro enviado!"
      subtitle="Recebemos sua solicitação. Aguarde a confirmação da administração do Clube.">
      <Button
        fullWidth
        variant="contained"
        color="primary"
        sx={{ height: 48 }}
        onClick={() => {
          window.location.href = window.location.origin + "/#/login";
        }}>
        Ir para o login
      </Button>
    </PublicAuthShell>
  );
};
